<template>
  <!-- 注册详情页 -->
  <div id="registerDetailList">
    <div style="width: auto;white-space: normal;text-align: right;margin-top: 20px;">
      <button class="cancelButtonTwo m_r_10 m_l_10" @click="goback">返回</button>
    </div>
    <div class="allTablePlace">
      <div>
        <nav v-if="$childMenu.indexOf('导出注册数据') >= 0" class="m_b_10"><button class="redButtonTwo" @click="exportList">导出</button></nav>
        <table cellspacing="0" class="allTable">
          <thead>
            <tr>
              <th class="t_c">微信昵称</th>
              <th class="t_c">注册时间</th>
              <th class="t_c">姓名</th>
              <th class="t_c">省份</th>
              <th class="t_c">城市</th>
              <th class="t_c">医院</th>
              <th class="t_c">科室</th>
              <!-- <th class="t_c">领域</th> -->
              <!-- <th class="t_c">适应症</th> -->
            </tr>
          </thead>
          <tbody>
            <template v-if="registerDetailList.length >0">
              <tr :key="index" v-for="(item, index) in registerDetailList">
                <td width="10%" class="t_c NoWrap" :title="item.wechatNickName">{{item.wechatNickName}}</td>
                <td width="10%" class="t_c" :title="item.subscribeTime">
                  {{item.subscribeTime}}
                </td>
                <td width="10%" class="t_c" :title="item.name">{{item.name}}</td>
                <td width="10%" class="t_c" :title="item.provice">
                  {{item.provice}}
                </td>
                <td width="10%" class="t_c" :title="item.city">{{item.city}}</td>
                <td width="10%" class="t_c" :title="item.instName">{{item.instName}}</td>
                <td width="10%" class="t_c" :title="item.department">{{item.department}}</td>
                <!-- <td width="10%" class="t_c" :title="item.field">{{item.field}}</td> -->
                <!-- <td width="10%" class="t_c" :title="item.indication">
                  {{item.indication}}
                </td> -->
              </tr>
            </template>
            <template v-else>
              <tr>
                <td style="border: none; text-align: center;" :colspan="7">暂无数据</td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <page v-if="totalPage !== 0" :totalCount="totalCount" v-on:on-getList="getRegisterDetailList($event)" :totalPage="totalPage" :page="page" :explain="0"></page>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
export default {
  name: 'registerDetailList',
  data () {
    return {
      channelID: this.$route.query.channelID,
      startTime: this.$route.query.startTime,
      endTime: this.$route.query.endTime,
      channelName: this.$route.query.channelName,
      categoryName: this.$route.query.categoryName,
      registerDetailList: [],
      page: 1,
      totalCount: 0,
      totalPage: 0,
      pageSize: 10
    }
  },
  created () {
    console.log(this.$route, '$route')
    // 获取注册详情
    this.getRegisterDetailList(1)
  },
  mounted () {

  },
  methods: {
    getRegisterDetailList (page) {
      this.page = page
      let params = {
        pageIndex: page,
        pageSize: this.pageSize
      }
      let startTime = this.startTime
      let endTime = this.endTime ? this.endTime + ' 23:59:59' : ''
      this.$axiox.post(`/api/ChannelQRCode/GetChanelQRRegisterDetail?channelID=${this.channelID}&startTime=${startTime}&endTime=${encodeURIComponent(endTime)}`, params).then(res => {
        console.log(res, '注册详情')
        if (res.data && res.data.length > 0) {
          this.registerDetailList = res.data
          this.totalCount = res.total
          this.totalPage = Math.ceil(res.total / this.pageSize)
        } else {
          this.registerDetailList = []
          this.totalCount = 0
          this.totalPage = 0
        }
      })
    },
    exportList () {
      let startTime = this.startTime
      let endTime = this.endTime ? this.endTime + ' 23:59:59' : ''
      axios.get(`/api/ChannelQRCode/ExportRegisterDetail?channelID=${this.channelID}&startTime=${startTime}&endTime=${encodeURIComponent(endTime)}`, {responseType: "arraybuffer"}).then(res => {
        console.log(res, 'exportList')
        const data = res.data
        const url = window.URL.createObjectURL(new Blob([data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"}))
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', this.channelName + '-注册详情.xlsx')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }).catch(err => {
        console.log(err, 'err')
      })
    },
    goback () {
      window.history.go(-1)
    }
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/qrCodeManager/registerDetailList.vue